
import {timer as observableTimer,  Observable ,  Subscription } from 'rxjs';
import { BaseTracking } from "app/core/tracking/base-tracking";
import { Config } from "app/core/vo/config";
import { HttpService } from "../../services/http.service";
import { UtilityScripts } from "app/helpers/utility-scripts";
import { Logger } from "../../helpers/Logger";
import { AppConstants } from "../vo/app-constants";

export class AICC extends BaseTracking {
	private newlnChar: string;
	private commDelay: number;
	private maxCommRetry: number;
	private useProxy: boolean;
	private proxyUrl: string;
	private aiccRetryCount: number;
	private strAICCData: string;
	private bFinishSent: boolean;
	private bSaving: boolean;
	private bFinishing: boolean;
	private savesInQueue: number;
	private httpMethod: string;
	private retryTimer: any;
	private strNewStatus: string;
	private intEscapeCount: number;
	private putVariables: any;
	private httpService: HttpService;
	private subscription: any;

	public init(configVO: any, _httpService: HttpService = null) {
		super.init(configVO);
		this.httpService = _httpService;
	}
	public initProperties(data) {
		super.initProperties(data);

		this.newlnChar = data.newlnChar;
		this.maxCommRetry = data.maxCommRetry;
		this.useProxy = data.useProxy;
		this.proxyUrl = data.proxyUrl;
		this.commDelay = data.commDelay;
		this.intEscapeCount = data.escapeCount;
		this.putVariables = {};
		this.bFinishSent = false;
		this.savesInQueue = 0;
		console.log("AICC PLAYER :: initProperties");
	}
	public initTrackingVO() {
		super.initTrackingVO();
		this.trackingVO.aicc_url =
			this.cbt_data.AICC_URL ||
			this.cbt_data.aicc_url ||
			this.cbt_data.Aicc_url;
		this.trackingVO.aicc_sid =
			this.cbt_data.AICC_SID ||
			this.cbt_data.aicc_sid ||
			this.cbt_data.Aicc_sid;
	}
	public doInitialize() {
		console.log("doInitilize called");
		this.httpMethod = "POST";
		this.aiccRetryCount = 0;
		this.aiccGet();
	}

	public aiccGet() {
		++this.aiccRetryCount;
		this.callGetParam();
	}
	public callGetParam() {
		let trackingParams_str =
			"command=GetParam&version=2.0&session_id=" +
			this.trackingVO.aicc_sid +
			"&aicc_url=" +
			this.trackingVO.aicc_url +
			"&aicc_data=";
		console.log("trackingParams_str>>>>>", trackingParams_str);
		this.httpService
			.ajax(this.httpMethod, this.getAiccUrl(), trackingParams_str, null)
			.then((res: any) => {
				console.log("res", res);
				if (res.ok) {
					this.handleSuccess(res.body);
				}
			})
			.catch((error) => {
				this.handleError(error);
			});
	}

	private handleSuccess(data) {
		console.log("handleSuccess", data);
		this.strAICCData = data;
		let variables: any = this.tidyLMSData(this.strAICCData);
		console.log(variables);
		if (variables["ERROR"] != null && variables["error"] == null) {
			variables["error"] = variables["ERROR"]; //Plateau can't follow a simple spec
		}
		if (variables["error"] != null) {
			this.parseAICCData(variables["error"]);
		} else {
			this.getRetry();
		}
	}
	private handleGetError(err) {
		console.log(2, "AICCFLOW:aiccGet:1:AICC GET success: false");
		console.log(2, "AICCFLOW:aiccGet:1:AICC Raw Data: ", err);
		console.log(2, "AICC GET ERROR : ", err);
		console.log(2, "AICCFLOW:aiccGet:2N:calling getRetry");
		this.strAICCData = err;
		this.getRetry();
	}
	public parseAICCData(response_str) {
		let time = ""; //"0000:00:15";
		console.log(2, "AICC: parseAICCData()", response_str);
		let AICCCoreHeader = "aicc_data=";
		response_str = UtilityScripts.searchReplace(response_str, "\r", "");
		console.log("response_str = ", response_str);
		let response_arr = response_str.split("\n");
		let count = 0;
		let countLen = response_arr.length;
		console.log(countLen + " response_arr = ", response_arr);
		for (count = 0; count < countLen; ++count) {
			let response_txt = response_arr[count].split("=");
			if (response_txt[0].toLowerCase() === "student_id") {
				this.trackingVO.studentId = response_txt[1];
			} else if (response_txt[0].toLowerCase() === "student_name") {
				this.trackingVO.studentName = response_txt[1];
			} else if (response_txt[0].toLowerCase() === "lesson_location") {
				if (response_txt[1] === "" || response_txt[1] === " ") {
					this.trackingVO.lessonLocation = "";
				} else {
					this.trackingVO.lessonLocation = response_txt[1];
					console.log(
						"parseAICCData() LessonLocation=" +
							this.trackingVO.lessonLocation +
							";" +
							this.trackingVO.lessonLocation.substr(
								this.trackingVO.lessonLocation.length - 1,
								this.trackingVO.lessonLocation.length
							) +
							";"
					);
				}
			} else if (response_txt[0].toLowerCase() === "lesson_status") {
				this.strOrigStatus = response_txt[1].substring(0, 1).toLowerCase();
				this.trackingVO.lessonStatus = this.strOrigStatus;
				console.log(
					"parseAICCData() > this.trackingVO.lessonStatus = " +
						this.trackingVO.lessonStatus
				);
			} else if (response_txt[0].toLowerCase() === "score") {
				this.trackingVO.score = response_txt[1];
			} else if (response_txt[0].toLowerCase() === "geolocation") {
				this.trackingVO.geoLocation = response_txt[1];
			} else if (response_txt[0].toLowerCase() === "time") {
				time = response_txt[1];
			} else if (
				response_txt[1] !== "" &&
				response_txt[1] !== undefined &&
				response_txt[1] !== " "
			) {
				console.log("my trackingVO", this.trackingVO);
				this.trackingVO[response_txt[0]] = response_txt[1];
			}
		}
		this.trackingVO["elt_total_time"] = UtilityScripts.resolveTime(
			this.trackingVO["elt_total_time"]
		);
		/* ------- Below code is added to handle the error in case the 'elt_total_time' is coming undefined --------------*/
		/*if(this.trackingVO['elt_total_time'] == 'undefined' || this.trackingVO['elt_total_time'] == undefined || this.trackingVO['elt_total_time'] == null || this.trackingVO['elt_total_time'] == "0"){
            let tmpArr = time.split(":");
            this.trackingVO['elt_total_time'] = UtilityScripts.pad(tmpArr[0],4,"0")+":"+UtilityScripts.pad(tmpArr[1],2,"0")+":"+UtilityScripts.pad(tmpArr[2],2,"0");
        }*/
		/* ----------------------------------------------------------------------------------------------------------------*/
		console.log(
			"parseAICCData() > strOrigStatus = " +
				this.strOrigStatus +
				" , completedVal = " +
				this.completedVal +
				" , lessonStatus = " +
				this.trackingVO.lessonStatus +
				" , quietComplete = " +
				this.quietComplete
		);
		if (
			this.trackingVO.lessonStatus === this.completedVal &&
			this.quietComplete
		) {
			if (this.strOrigStatus !== this.completedVal) {
				this.doFinish(); //Turn off tracking if LMS stops listening after completion
			}
		} else if (
			this.strOrigStatus !== "c" &&
			this.strOrigStatus !== "i" &&
			this.strOrigStatus !== "p" &&
			this.trackingVO.lessonStatus !== "c" &&
			this.strOrigStatus !== this.completedVal
		) {
			//For non-compliant APIs (oh, wait, that's all of them...)
			this.trackingVO.lessonStatus = "i";
			this.strOrigStatus = this.trackingVO.lessonStatus;
		}
		this.notifyInitialize();
	}

	public doFinish(): any {
		if (
			this.bFinishSent ||
			(this.strOrigStatus === this.completedVal && this.quietComplete)
		) {
			console.log(4, "AICCFLOW:calling over and out.....");
		} else {
			if (this.timeSingleSend && this.quietComplete) {
				this.timeSingleSend = false; //set this.timeSingleSend to false so that time will be appended to aicc data
				this.doCommit();
			}
			if (this.bSaving) {
				console.log(
					4,
					"AICCFLOW:finish:2Y - Saving is true. Making finishing = true "
				);
				this.bFinishing = true;
			} else {
				this.bFinishSent = true;
				console.log(
					2,
					"AICCFLOW:finish:2N: ExitAU. Sending Data to LMS ----------------------"
				);
				let trackingParams_str =
					"command=exitau&version=2.0&session_id=" +
					this.trackingVO.aicc_sid +
					"&aicc_url=" +
					this.trackingVO.aicc_url;

				this.httpService
					.ajax(this.httpMethod, this.getAiccUrl(), trackingParams_str, null)
					.then((res: any) => {
						console.log("res", res);
						if (res.ok) {
							this.handleFinishComplete(res.body);
						}
					})
					.catch((error) => {});
				(window as any).disableExitConfirmation();
			}
		}
		return false;
	}
	public doCommit(isExitButtonClicked = false) {
		this.savesInQueue++;
		if (this.savesInQueue < 6) {
			console.log(
				4,
				"commit	() saving: " +
					this.bSaving +
					" commits in queue (incl this one): " +
					this.savesInQueue
			);
			console.log(
				4,
				"AICCFLOW:commit:1N:Saving is false, Make saving = true and Save"
			);

			this.aiccRetryCount = 0;
			if (this.strOrigStatus === this.completedVal) {
				//Course is already completed
				console.log(4, "AICCFLOW:commit:2Y:Course is already complete.");
				this.trackingVO.lessonStatus = this.completedVal;
			} else {
				// console.log( 4, 'AICCFLOW:commit:2N:Course not complete on launch. Check for Lesson_status:' + this.trackingVO.lessonStatus );
				if (
					this.trackingVO.lessonStatus !== "i" &&
					this.trackingVO.lessonStatus !== this.completedVal
				) {
					this.trackingVO.lessonStatus = this.strOrigStatus;
				}
			}
			if (this.bSaving) {
				if (this.bFinishSent) {
					console.log(
						2,
						"AICC - Catch Error - Course is attempting to bookmark after completion has been sent."
					);
					this.bSaving = false;
					this.savesInQueue = 0;
				} else {
					this.aiccPut(isExitButtonClicked);
					//this.addEventListener( 'putComplete', Delegate.create( this, nextSave ) );
				}
			} else {
				this.aiccPut(isExitButtonClicked);
			}
		} else {
			alert(
				"The course is unable to save your progress.  Please close this window and relaunch the course."
			);
		}
		return false;
	}
	public formAICCData() {
		let aicc_udata: string = "[core]" + this.newlnChar;
		aicc_udata +=
			"lesson_location=" + this.trackingVO.lessonLocation + this.newlnChar;
		aicc_udata +=
			"lesson_status=" + this.trackingVO.lessonStatus + this.newlnChar;
		this.strNewStatus = this.trackingVO.lessonStatus;
		console.log(
			4,
			"formAICCData:1:Assigning new status : " + this.trackingVO.lessonStatus
		);

		if (!this.timeSingleSend) {
			switch (this.timeSaveMode) {
				case 0:
					aicc_udata += "time=0:00:00" + this.newlnChar;
					break;
				case 1:
					console.log(4, "AICCFLOW:formAICCData:2Y: timeSaveMode is 1");
					aicc_udata += "time=" + this.trackingVO.sessionTime + this.newlnChar;
					break;
				case 2:
					console.log(4, "AICCFLOW:formAICCData:2Y: timeSaveMode is 2");
					aicc_udata += "time=" + this.trackingVO.totalTime + this.newlnChar;
					break;
				case 3:
					console.log(4, "AICCFLOW:formAICCData:2Y: timeSaveMode is 3");
					aicc_udata += "time=0:00:00" + this.newlnChar;
					break;
			}
		} else {
			console.log(
				2,
				"AICCFLOW:formAICCData:2N : AICC: timeSingleSend is set to : " +
					this.timeSingleSend
			);
		}
		//this.trackingVO.score = parseInt( this.trackingVO.score.tostring() );
		/*if (isNaN(this.trackingVO.score)) {
            this.trackingVO.score = NaN;
        }*/
		//if ( !this.trackingVO.score && ((this.trackingVO.score < 50) || this.trackingVO.score == null) ) { //|| this.trackingVO.score.tostring() == '')
		if (this.trackingVO.score < 50) {
			console.log(
				4,
				"AICCFLOW:formAICCData:3Y: Check scoreMode: " + Number(this.scoreMode)
			);
			switch (Number(this.scoreMode)) {
				case 0:
					console.log(4, "AICCFLOW:formAICCData:3Y: score mode is 0");
					break;
				case 1:
					console.log(4, "AICCFLOW:formAICCData:3Y: score mode is 1");
					break;
				case 2:
					console.log(4, "AICCFLOW:formAICCData:3Y: score mode is 2");
					this.trackingVO.score = 0;
					aicc_udata += "score=" + this.trackingVO.score + this.newlnChar;
					break;
				case 3:
					console.log(4, "AICCFLOW:formAICCData:3Y: score mode is 3");
					this.trackingVO.score = null;
					aicc_udata += "score=" + this.newlnChar;
					break;
			}
		} else {
			console.log(
				4,
				"AICCFLOW:formAICCData:3N: Check score  : " +
					Number(this.trackingVO.score)
			);
			/*if ( this.trackingVO.score && this.strNewStatus === this.completedVal) {
                aicc_udata += "score=" + this.trackingVO.score + this.newlnChar;
            }else if (Number( this.scoreMode ) > 0 && isNaN( Number ( this.trackingVO.score ) ) !== true ) {
                console.log( 4, 'AICCFLOW:formAICCData:3N: Setting the score  : '+ this.trackingVO.score);
                aicc_udata += "score=" + this.trackingVO.score + this.newlnChar;
            }*/

			//
			if (Number(this.scoreMode) > 0) {
				//&& this.trackingVO.score != null )
				console.log(
					4,
					"AICCFLOW:formAICCData:3N: Setting the score  : " +
						this.trackingVO.score
				);
				aicc_udata += "score=" + this.trackingVO.score + this.newlnChar;
			}
		}

		// ---- Start [core_lesson] -------------------
		console.log(4, "AICCFLOW:formAICCData:5: [core_lesson]");
		aicc_udata += "[core_lesson]" + this.newlnChar;
		if (this.trackingVO.bookmark == null || this.trackingVO.bookmark === "") {
			console.log(4, "AICCFLOW:formAICCData:6Y: Invalid bookmark");
			//_root.toast( 'Bookmark Failure', 'The course was unable to save your progress.  Please close this window and try again.', '' );
			//_root.stopEverything();
			alert(
				"The course was unable to save your progress.  Please close this window and try again."
			);

			return null;
		}

		console.log(4, "AICCFLOW:formAICCData:7: add bookmark to suspend data");
		let suspendData: string =
			"bookmark=" + this.trackingVO.bookmark + this.newlnChar;
		//Bookmark Timer -----------\/
		//if ( timeSaveMode > 0 ) {
		//sessionTime is sent for reporting and such, but totalTime is the time used in the course, since the spec is lacking
		console.log(
			4,
			"AICCFLOW:formAICCData:8:Saving totalTime in bookmark : " +
				this.trackingVO.totalTime
		);
		suspendData +=
			"elt_total_time=" +
			UtilityScripts.resolveTime(this.trackingVO.totalTime) +
			this.newlnChar;
		//}
		if (this.trackingVO.geoLocation != null) {
			suspendData +=
				"geoLocation=" + this.trackingVO.geoLocation + this.newlnChar;
		}
		if (
			this.strOrigStatus !== this.completedVal &&
			this.strNewStatus === this.completedVal
		) {
			console.log(4, "AICCFLOW:formAICCData:9Y:Setting completion date");
			suspendData +=
				"completion_date=" + this.trackingVO.completionDate + this.newlnChar;
			suspendData +=
				"content_version=" + AppConstants.VERSION_NUM + this.newlnChar;
		}
		//else if ( this.trackingVO.completion_date.tostring() != null)
		else {
			//If the completion date was previously set, don't loose it
			console.log(
				4,
				"AICCFLOW:formAICCData:10Y: get the previously set completion date"
			);
			suspendData +=
				"completion_date=" + this.trackingVO.completionDate + this.newlnChar;
			suspendData +=
				"content_version=" + AppConstants.VERSION_NUM + this.newlnChar;
		}

		if (this.trackingVO.score) {
			suspendData += "score=" + this.trackingVO.score + this.newlnChar;
		}

		if(this.trackingVO.rubricStatus) {
            suspendData += 'rubricStatus=' + this.trackingVO.rubricStatus;
        }
		// Note browser information
		suspendData += UtilityScripts.browserAndSystemInfo(this.newlnChar);
		suspendData += "&complianceTypeID>"+this.trackingVO.complianceTypeID + this.newlnChar;
		suspendData += "&complianceTypeName>"+this.trackingVO.complianceTypeName;
		// ------------------------------------------------
		console.log(2, "AICCFLOW:formAICCData:11:calling escape on suspendData");
		aicc_udata +=
			UtilityScripts.dataEscapeUnescape(
				suspendData,
				"escape",
				this.intEscapeCount
			) + this.newlnChar;
		console.log("formAICCData aicc_udata    :", aicc_udata);
		return aicc_udata;
	}
	private aiccPut(isExitButtonClicked: boolean = false) {
		this.bSaving = true;
		this.aiccRetryCount++;
		this.putVariables = {};

		let aicc_out_lv: any = this.formAICCData();
		let trackingParams_str; // = 'command=PutParam&version=3.0.2&session_id=' + this.trackingVO.aicc_sid + '&aicc_url=' + this.trackingVO.aicc_url + '&aicc_data='+aicc_out_lv;
		console.log("aneesh_aicc_out_lv   : ", escape(aicc_out_lv));
		/*if(isExitButtonClicked)
            trackingParams_str = 'command=exitau&version=3.0.2&session_id=' + this.trackingVO.aicc_sid + '&aicc_url=' + this.trackingVO.aicc_url;
        else*/
		trackingParams_str =
			"command=PutParam&version=2.0&session_id=" +
			this.trackingVO.aicc_sid +
			"&aicc_url=" +
			this.trackingVO.aicc_url +
			"&aicc_data=" +
			escape(aicc_out_lv);

		let sendData = true;
		if (aicc_out_lv) {
			if (!isExitButtonClicked) {
				if (this.bkMkFreq == 0) {
					sendData = false;
				}
			}
			if (
				(this.strOrigStatus !== this.completedVal &&
					this.quietComplete &&
					sendData) ||
				!this.quietComplete
			) {
				if (!this.bFinishSent || this.quietComplete !== true) {
					console.log("trackingParams_str   ", trackingParams_str);
					this.httpService
						.ajax(this.httpMethod, this.getAiccUrl(), trackingParams_str, null)
						.then((res: any) => {
							console.log("res", res);
							if (res.ok) {
								this.handlePutParamComplete(res.body);
							}
						})
						.catch((error) => {
							this.handlePutParamError(error);
						});
				} else if (
					this.quietComplete &&
					this.trackingVO.lessonStatus === this.completedVal
				) {
					console.log(
						4,
						"QuietComplete is true and the course is complete, belay that save!"
					);
					//QuietComplete is true and the course is complete, belay that save!
					this.bSaving = false;
					console.log(4, "savesInQueue Dec 2");
					this.savesInQueue--;
					if (this.bFinishing === true && this.bFinishSent !== true) {
						console.log(4, "AICCFLOW:aiccPut:6Yb1: calling finish().");
						this.doFinish();
					}
				}
			} else {
				console.log(
					4,
					"AICCFLOW:aiccPut:3Y: course completed. Do not call putparam. orig_status =" +
						this.strOrigStatus
				);
				this.bSaving = false;
				console.log(4, "savesInQueue Dec 3");
				this.savesInQueue--;
				if (
					this.quietComplete &&
					this.trackingVO.lessonStatus === this.completedVal
				) {
					//dispatchEvent( { type:'saveSuccess', target:this } );
				}
				if (this.bFinishing === true && this.savesInQueue === 0) {
					console.log(4, "AICCFLOW:aiccPut:6Yb2: calling finish().");
					this.doFinish();
				}
			}
		} else {
			console.log(
				4,
				"AICCFLOW:aiccPut:3N: No bookmark data present in cbt_data.bookmark.  Unable to save"
			);
		}
	}
	private setUpUrlVariables(data) {
		this.putVariables = this.tidyLMSData(data);
		if (
			this.putVariables["Error"] != null &&
			this.putVariables["error"] == null
		) {
			this.putVariables["error"] = this.putVariables["Error"]; //Not everyone can follow a simple spec
		}
		if (
			this.putVariables["ERROR"] != null &&
			this.putVariables["error"] == null
		) {
			this.putVariables["error"] = this.putVariables["ERROR"]; //Plateau can't follow a simple spec
		}
	}
	private handlePutParamComplete(strData: string) {
		const display_str: string = unescape(strData);
		let isBadData;
		console.log(4, "AICCFLOW:aiccPut:4Y:Response from LMS (Raw): " + strData);
		try {
			this.setUpUrlVariables(strData);
		} catch (error) {
			console.log(4, "AICCFLOW:aiccPut:4Y:Response from LMS ERROR: " + strData);
			if (this.aiccRetryCount < this.maxCommRetry) {
				console.log(
					4,
					"AICCFLOW:aiccPut:10: AICC: Trying again in " +
						this.commDelay +
						" seconds."
				);

				this.startTimer(this.handleInvokeRetryPut.bind(this));
			} else {
				console.log(
					4,
					"AICCFLOW:aiccPut:7N: AICC: All Requests Failed - Giving up"
				);
				console.log(
					4,
					"AICCFLOW:aiccPut:8Y: AICC: Request successful but data was bad.\nReceived:\n" +
						strData
				);

				isBadData = true;
				if (this.retryTimer) {
					this.stopTimer();
				}
				console.log(
					4,
					"AICCFLOW:aiccPut:8Y: AICC: Request successful but data was bad......" +
						display_str
				);
				//EventManager.dispatchEvent(new AppEvent(AppEvent.TOAST,{header:"Save Failed",body:"The course is unable to save your progress.Please close this window and launch the course again to resume your training.  If the problem persists, please contact your help desk.",footer:'Error Code: '+ display_str.substring( 0, 120)}));

				if (!isBadData) {
					//EventManager.dispatchEvent(new AppEvent(AppEvent.TOAST,{header:"Save Failed",body:"The course is unable to save your progress.Please close this window and launch the course again to resume your training.  If the problem persists, please contact your help desk.",footer:'Error Code: '+ putVariables["error"].substring( 0, 120) }));
				}
			}
			return;
		}
		console.log("putvaroubles   : ", this.putVariables["error"]);
		console.log(
			"putvaroubles [error][error]   : ",
			this.putVariables["error"]["error"]
		);
		if (this.putVariables["error"].toLowerCase().indexOf("error=0") !== -1) {
			console.log(4, "savesInQueue Dec 1");
			this.savesInQueue--;
			console.log(4, "Commits in queue (after this one): " + this.savesInQueue);
			console.log(
				2,
				"AICCFLOW:aiccPut:5Y:----- Response Received -------------------"
			);
			console.log(
				2,
				"AICCFLOW:aiccPut:5Y:----- End of Response from LMS ------------"
			);
			this.bSaving = false;

			console.log(
				4,
				"AICCFLOW:aiccPut:5Y:AICC: save complete, finishing is " +
					this.bFinishing
			);
			console.log(
				4,
				"AICCFLOW:aiccPut:5Y:AICC:thisObj.quietComplete " + this.quietComplete
			);
			console.log(
				4,
				"AICCFLOW:aiccPut:5Y:AICC: thisObj.cbt_data.lessonStatus " +
					this.trackingVO.lessonStatus
			);
			console.log(
				4,
				"AICCFLOW:aiccPut:5Y:AICC: save complete, thisObj.completedVal " +
					this.completedVal
			);

			if (
				this.bFinishing ||
				(this.quietComplete &&
					this.trackingVO.lessonStatus === this.completedVal)
			) {
				if (
					this.quietComplete &&
					this.trackingVO.lessonStatus === this.completedVal
				) {
					console.log(
						4,
						"AICCFLOW:aiccPut:5Y:AICC: setting savesInQueue to 0 "
					);
					this.savesInQueue = 0;
				}
				console.log(
					4,
					"AICCFLOW:aiccPut:5Y:AICC: _root.exiting  = " + AppConstants.isExiting
				);

				if (this.savesInQueue === 0 || AppConstants.isExiting) {
					console.log(4, "AICCFLOW:aiccPut:6Ya: calling finish().");
					this.doFinish();
				}
			}

			console.log(
				4,
				"quietComplete: " +
					this.quietComplete +
					" lesson_status: " +
					this.trackingVO.lessonStatus +
					" completedVal: " +
					this.completedVal +
					" savesInQueue: " +
					this.savesInQueue
			);
			if (
				(this.quietComplete &&
					this.trackingVO.lessonStatus === this.completedVal) ||
				this.savesInQueue <= 0
			) {
				//	dispatchEvent( { type:'saveSuccess', target:thisObj } );
				this.savesInQueue = 0;
				console.log("this.savesInQueue     :", this.savesInQueue);
			} else {
				this.aiccPut();
				//Don't call this if quietComplete is true and the course is complete, no matter how many saves are queued:
				//dispatchEvent(new Event(NEXT_SAVE));
				//dispatchEvent( { type:'nextSave', target:thisObj } );
			}
		} else {
			isBadData = false;
			if (
				parseInt(this.putVariables["error"]) > 0 &&
				!isNaN(parseInt(this.putVariables["error"]))
			) {
				console.log(
					4,
					"AICCFLOW:aiccPut:7Y: AICC: Error Code " +
						parseInt(this.putVariables["error"]) +
						" returned from LMS"
				);
				let error_text: string = this.putVariables["error"];
				//EventManager.dispatchEvent(new AppEvent(AppEvent.TOAST,{header:"Save Failed",body:"The course is unable to save your progress.Please close this window and launch the course again to resume your training.  If the problem persists, please contact your help desk.",footer:"Error Code: "+error_text.substring( 0, 120)}));
			} else if (this.aiccRetryCount >= this.maxCommRetry) {
				console.log(
					4,
					"AICCFLOW:aiccPut:7N: AICC: All Requests Failed - Giving up"
				);
				console.log(
					4,
					"AICCFLOW:aiccPut:8Y: AICC: Request successful but data was bad.\nReceived:\n" +
						strData
				);

				isBadData = true;
				if (this.retryTimer) {
					this.stopTimer();
				}
				console.log(
					4,
					"AICCFLOW:aiccPut:8Y: AICC: Request successful but data was bad......" +
						display_str
				);
				//EventManager.dispatchEvent(new AppEvent(AppEvent.TOAST,{header:"Save Failed",body:"The course is unable to save your progress.Please close this window and launch the course again to resume your training.  If the problem persists, please contact your help desk.",footer:'Error Code: '+ display_str.substring( 0, 120)}));
			} else {
				console.log(
					4,
					"AICCFLOW:aiccPut:9Y: AICC: Request successful but data was bad.\nReceived:\n" +
						this.putVariables
				);
				console.log(
					4,
					"AICCFLOW:aiccPut:10: AICC: Trying again in " +
						this.commDelay +
						" seconds."
				);

				this.startTimer(this.handleInvokeRetryPut.bind(this));
			}
		}
	}
	private handlePutParamError(err) {
		console.log(4, "AICCFLOW:aiccPut:8N: AICC: Request unsuccessful");
		console.log(
			4,
			"AICCFLOW:aiccPut:10: AICC: Trying again in " +
				this.commDelay +
				" seconds."
		);

		if (this.aiccRetryCount < this.maxCommRetry) {
			this.startTimer(this.handleInvokeRetryPut.bind(this));
		} else {
			alert(
				"The course is unable to save your progress.Please close this window and launch the course again to resume your training.  If the problem persists, please contact your help desk.<br><br>Error message: "
			);
		}
	}
	private startTimer(callback: Function) {
		const time = this.commDelay * 1000;
		this.stopTimer();
		this.retryTimer = observableTimer(time, 1);
		this.subscription = this.retryTimer.subscribe((event) => {
			callback(event);
		});
	}
	private stopTimer() {
		if (this.subscription) {
			this.subscription.unsubscribe();
			this.retryTimer = null;
		}
	}
	private handleInvokeRetryPut(evt) {
		console.log(4, "handleInvokeRetryPut()");
		this.stopTimer();
		this.aiccPutRetry();
	}
	private aiccPutRetry() {
		console.log(
			2,
			"Communication failed; retrying; aiccRetryCount is " + this.aiccRetryCount
		);
		this.aiccPut();
	}
	private handleFinishComplete(res) {
		this.bFinishing = false;
	}
	public tidyLMSData(variables: string): any {
		//let fixVars = unescape( variables );
		let fixVars = UtilityScripts.dataEscapeUnescape(
			variables,
			"unescape",
			this.escapeCount
		);
		fixVars = fixVars.split(" = ").join("=");
		const startPos: number = fixVars.toLowerCase().indexOf("error=");
		if (startPos !== 0) {
			fixVars = fixVars.substring(startPos, fixVars.length);
			console.log(
				2,
				"AICCFLOW:tidyLMSData:1:tidyLMSData removed " +
					startPos +
					" leading characters; new data is:\n" +
					fixVars
			);
		}
		//variables.decode( fixVars );

		return { error: fixVars };
	}
	private handleError(err) {
		this.strAICCData = err;
		this.getRetry();
	}
	private getRetry() {
		if (this.aiccRetryCount >= this.maxCommRetry) {
			if (this.httpMethod === "POST") {
				console.log(
					2,
					"AICCFLOW:getRetry:4Y: AICC Switching HTTP Method from POST to GET."
				);
				this.httpMethod = "GET";
				this.aiccRetryCount = 0;
				this.aiccGet();
			} else if (!this.useProxy && this.proxyUrl) {
				console.log(
					2,
					"AICCFLOW:getRetry:5Y: AICC Switching HTTP Method back to POST and trying proxy:\n" +
						this.proxyUrl
				);
				this.httpMethod = "POST";
				this.useProxy = true;
				this.aiccRetryCount = 0;
				this.aiccGet();
			} else {
				console.log(2, "AICCFLOW:getRetry:6Y: Checking cross domain");
				this.aiccRetryCount = 0;
			}
		} else {
			this.startTimer(this.handleInvokeRetry.bind(this));
		}
	}
	private handleInvokeRetry(evt) {
		this.stopTimer();
		this.aiccGet();
	}
	private getAiccUrl(): string {
		if (this.useProxy && this.proxyUrl != null) {
			console.log("this.proxyUrl>>>>> ", this.proxyUrl);
			return this.proxyUrl;
		}
		return this.trackingVO.aicc_url;
	}
}

declare function unescape(s: string): string;
declare function escape(s: string): string;
